/**
 * Where the other two surfaces answer. The manual links back to the site and
 * forward to the account area; both are separate deployments, so both are
 * variables with same-origin defaults (see `site/src/lib/links.ts` for the
 * same note — the three projects share nothing, including this).
 */
export const SITE_URL = import.meta.env.VITE_SITE_URL ?? '/';
export const ACCOUNT_URL = import.meta.env.VITE_ACCOUNT_URL ?? '/account';
